import { render, staticRenderFns } from "./addEditSidebar.vue?vue&type=template&id=2d846a1c&scoped=true&"
import script from "./addEditSidebar.vue?vue&type=script&lang=js&"
export * from "./addEditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./addEditSidebar.vue?vue&type=style&index=0&id=2d846a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d846a1c",
  null
  
)

export default component.exports